export enum TaskType {
  InboundCall = 'inbound-call',
  InboundForm = 'inbound-form',
  InboundNonReception = 'inbound-non-reception',
  OutboundVisitConfirmation = 'outbound-visit-confirmation',
  OutboundCall = 'outbound-call',
}
